// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"88":"7c351e45","135":"3c38f492","401":"c5617012","489":"1f4eacaf","521":"5ebb3921","573":"4e83b285","746":"45717859","844":"6d6cab49","848":"4e3a0fb4","902":"3dd092a9","955":"77835eaa","975":"dad6ae73"}[chunkId] + ".chunk.js";
};